import { render } from "./ListeFicheInventaire.vue?vue&type=template&id=2c1537d5&ts=true"
import script from "./ListeFicheInventaire.vue?vue&type=script&lang=ts"
export * from "./ListeFicheInventaire.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__